import styled from "styled-components";

export const Section = styled.section`
  padding: 75px 0;
  background-color: ${(props) => props.theme.colors.contact};
  text-align: center;
`;

export const ContactContainer = styled.div`
  display: flex;
  margin: 0 auto;
  align-items: center;
  gap: 20px;
  justify-content: space-between;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const StyledContetntWrapper = styled.div`
  position: relative;
  text-align: left;
`;

export const ContactTitle = styled.h2`
  font-size: 2.5rem;
  margin-bottom: 1rem;
  color: ${(props) => props.theme.colors.background};
`;

export const ContactDescription = styled.p`
  font-size: 1.2rem;
  color: ${(props) => props.theme.colors.background};
`;

export const PhoneContainer = styled.div`
  display: inline-block;
`;

export const PhoneLabel = styled.strong`
  display: block;
  font-size: 1.2rem;
  color: ${(props) => props.theme.colors.secondary};
`;

export const PhoneNumber = styled.a`
  background-color: ${(props) => props.theme.colors.primary};
  padding: 15px 30px;
  border-radius: 100px;
  font-size: 1.4rem;
  font-weight: bold;
  color: ${(props) => props.theme.colors.background};
  text-decoration: none;
  &:hover {
    color: ${(props) => props.theme.colors.secondary};
    text-decoration: none;
  }
`;
